/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Ean_TakenInputs */

const en_issue_ean_taken = /** @type {(inputs: Issue_Ean_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`already used by another SKU`)
};

/**
* | output |
* | --- |
* | "already used by another SKU" |
*
* @param {Issue_Ean_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_ean_taken = /** @type {((inputs?: Issue_Ean_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Ean_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_ean_taken(inputs)
});